import { tokens } from '@cellula/react-theme-patient';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const StyledPageWidthLimiter = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1240px;
	margin: 0 auto;
	width: 100%;
	padding: ${tokens.spacing.x2} ${tokens.spacing.x2};

	${tokens.breakpointQuery.medium} {
		padding: ${tokens.spacing.x4} ${tokens.spacing.x4};
	}
`;

export function PageWidthLimiter({ children }: PropsWithChildren) {
	return <StyledPageWidthLimiter>{children}</StyledPageWidthLimiter>;
}
